/**
 * seasons selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

interface State {
    seasons: {
        [string]: {
            name: string
        }
    };
}

interface Props {
    seasonId?: number | string;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectSeasons = (state: State) => state.seasons;
const selectSeasonId = (state: State, props: Props) =>
    props.seasonId && `${props.seasonId}`;

const selectSeasonsArray = createDeepEqualSelector(
    selectSeasons,
    seasonsState => Object.values(seasonsState)
);

const selectSeason = createDeepEqualSelector(
    selectSeasons,
    selectSeasonId,
    (seasonsState, seasonId) => seasonId && seasonsState[seasonId]
);

const makeSelectSeasonValue = (field: string) =>
    createDeepEqualSelector(
        selectSeason,
        seasonState => seasonState && seasonState[field]
    );

export {
    selectSeasonsArray,
    selectSeasons,
    selectSeason,
    makeSelectSeasonValue
};
